import { lazy } from "react";

// Full-screen game routes, code-split so each game only loads when played.
export const GAME_ROUTES = {
  "/games/target-rush": lazy(() => import("../pages/TargetRush")),
  "/games/reflex-duel": lazy(() => import("../pages/ReflexDuel")),
  "/games/speed-round": lazy(() => import("../pages/SpeedRound")),
  "/games/dodge": lazy(() => import("../pages/Dodge")),
  "/games/impossible-mode": lazy(() => import("../pages/ImpossibleMode")),
  "/brain/sequence-memory": lazy(() => import("../pages/brain/SequenceMemory")),
  "/brain/number-memory": lazy(() => import("../pages/brain/NumberMemory")),
  "/brain/verbal-memory": lazy(() => import("../pages/brain/VerbalMemory")),
  "/brain/chimp-test": lazy(() => import("../pages/brain/ChimpTest")),
  "/brain/visual-memory": lazy(() => import("../pages/brain/VisualMemory")),
  "/brain/aim-trainer": lazy(() => import("../pages/brain/AimTrainer")),
  "/brain/typing-speed": lazy(() => import("../pages/brain/TypingSpeed")),
  "/games/ghost-tap": lazy(() => import("../pages/originals/GhostTap")),
  "/games/dual-mind": lazy(() => import("../pages/originals/DualMind")),
  "/games/blink": lazy(() => import("../pages/originals/Blink")),
  "/games/nerve": lazy(() => import("../pages/originals/Nerve")),
  "/games/color-trap": lazy(() => import("../pages/originals/ColorTrap")),
  "/games/odd-one-out": lazy(() => import("../pages/originals/OddOneOut")),
  "/games/flip": lazy(() => import("../pages/originals/Flip")),
  "/games/mirror": lazy(() => import("../pages/originals/Mirror")),
  "/games/pulse": lazy(() => import("../pages/originals/Pulse")),
  "/games/peripheral": lazy(() => import("../pages/originals/Peripheral")),
  "/games/tracking": lazy(() => import("../pages/originals/Tracking")),
  "/games/schulte": lazy(() => import("../pages/originals/Schulte")),
  "/games/bullseye": lazy(() => import("../pages/originals/Bullseye")),
  "/games/cascade": lazy(() => import("../pages/originals/Cascade")),
  "/games/sprint": lazy(() => import("../pages/originals/Sprint")),
  "/games/click-speed": lazy(() => import("../pages/originals/ClickSpeed")),
  "/games/spacebar-speed": lazy(() => import("../pages/originals/SpacebarSpeed")),
  "/games/lights-out": lazy(() => import("../pages/originals/LightsOut")),
  "/games/quick-draw": lazy(() => import("../pages/originals/QuickDraw")),
  "/games/echo": lazy(() => import("../pages/originals/Echo")),
};

export const embedGame = (slug) => GAME_ROUTES[`/games/${slug}`] || GAME_ROUTES[`/brain/${slug}`];
